<template>
  <div class="contract-list" :class="{ 'hide-arrow-left': tabId == '0', 'hide-arrow-right': Number(tabId) + 1 == fileList.length }">
    <Tabs v-model="tabId" :animated="false">
      <TabPane
        v-for="(bean, i) in fileList"
        :key="bean.id"
        :label="(bean.fileName && bean.fileName.substr(0, bean.fileName.length - 4)) || bean.subject"
        :name="i + ''"
      ></TabPane>
    </Tabs>
    <iframe :src="curData.fileDownloadUrl" frameborder="0" :height="iframeH || tableH"></iframe>
  </div>
</template>

<script>
export default {
  props: ['fileList', 'iframeH'],
  data() {
    return {
      tableH: document.body.clientHeight - 320,
      tabId: '0'
    };
  },
  computed: {
    curData() {
      const data = this.fileList[this.tabId];
      return data || {};
    }
  },
  created() {
    window.addEventListener('resize', () => {
      this.tableH = document.body.clientHeight - 320;
    });
  }
};
</script>
<style lang="scss" scoped>
.contract-list {
  iframe {
    width: 100%;
  }
}
.hide-arrow-left {
  /deep/ .ivu-tabs-nav-prev {
    display: none;
  }
}
.hide-arrow-right {
  /deep/ .ivu-tabs-nav-next {
    display: none;
  }
}
</style>
